module.exports = __webpack_public_path__ + "static/media/LGBTQFounderUpdated.d21fe00b.svg";